import { Injectable } from '@angular/core';
import { ApiService } from '../common';
import { API_ENDPOINT } from '../../configs';
import { VersionDTO } from '../../models/dto/version.dto';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  constructor(
    private readonly http: ApiService,
  ) {
  }

  getAll() {
    return this.http.get(
      API_ENDPOINT.version.controller + API_ENDPOINT.version.getAll,
    );
  }

  getDetail(id: number) {
    return this.http.get(
      API_ENDPOINT.version.controller + API_ENDPOINT.version.getDetail + id,
    );
  }

  createVersion(data: VersionDTO) {
    const formData = new FormData();
    formData.append('startDatetime', data.startDatetime.toISOString());
    formData.append('version', data.version);
    formData.append('file', data.file);
    return this.http.postFormData(
      API_ENDPOINT.version.controller + API_ENDPOINT.version.create,
      formData,
    );
  }

  updateVersion(data: VersionDTO, id: number) {
    const formData = new FormData();
    formData.append('startDatetime', data.startDatetime.toISOString());
    formData.append('version', data.version);
    formData.append('file', data.file);
    formData.append('skipAttachment', JSON.stringify(Number(data.skipAttachment)));
    return this.http.putFormData(
      API_ENDPOINT.version.controller + API_ENDPOINT.version.update + id,
      formData,
    );
  }

  deleteVersion(id: number) {
    return this.http.delete(
      API_ENDPOINT.version.controller + API_ENDPOINT.version.delete + id,
    );
  }

  getAttachment(id: number) {
    return this.http.get(
      API_ENDPOINT.version.controller + API_ENDPOINT.version.getAttachment + id,
    );
  }
}
